import { app } from '../../app.module'
app
  // アカウントの投稿数グラフの表示
  .directive('accountPostCount', () => {
    return {
      restrict: 'E',
      template: require('./account-post-count.pug')(),
    }
  })
